import React, { useEffect, useState } from 'react';
import FOG from 'vanta/dist/vanta.fog.min';
// import CELLS from 'vanta/dist/vanta.cells.min';
import styles from './Step.module.css';
import VerticalLinearStepper from './Flow';

const Step = () => {
  const [vantaEffect, setVantaEffect] = useState(null);

  useEffect(() => {
    if (!vantaEffect) {
      setVantaEffect(FOG({
        el: "#vanta3",
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.00,
        minWidth: 200.00,
        highlightColor: 0x2b1a39,
        midtoneColor: 0x14062a,
        lowlightColor: 0x110a25,
        baseColor: 0x0
        // mouseControls: true,
        // touchControls: true,
        // gyroControls: false,
        // highlightColor: 0xffffff,
        // midtoneColor: 0xa7a7a7,
        // lowlightColor: 0x7c65e8,
        // baseColor: 0x3a156e
      }));
    }
    return () => {
      if (vantaEffect) vantaEffect.destroy();
    };
  }, [vantaEffect]);

  // useEffect(() => {
  //   if (!vantaEffect) {
  //     setVantaEffect(CELLS({
  //       el: "#vanta3",
  //       mouseControls: true,
  //       touchControls: true,
  //       gyroControls: false,
  //       minHeight: 200.00,
  //       minWidth: 200.00,
  //       scale: 1.00,
  //       color1: 0x111111,
  //       color2: 0x4d2f91,
  //       size: 3.20,
  //       speed: 4.40
  //     }));
  //   }
  //   return () => {
  //     if (vantaEffect) vantaEffect.destroy();
  //   };
  // }, [vantaEffect]);

  return (
    <section className={styles.step_area}>
      <h2>納品までの<span>流れ</span></h2>
      <p>納品までは簡単な3ステップで、<br className="sp" />完了いたします。</p>
      <div className={styles.contents}>
        <VerticalLinearStepper />
        <div className={styles.vanta} id='vanta3'></div>
      </div>
    </section>
  );
}

export default Step;
